function OpenTooltips() {
  const elements = document.querySelectorAll('[data-modal-id]');

  [...elements].forEach((element) => {
    element.addEventListener('click', () => {
      let id = element.dataset.modalId;
      let target = document.getElementById(id);

      if (target.classList.contains('show-tooltips')) {
        return;
      } else {
        CloseTooltips();
        target.classList.add('show-tooltips');
      }
    });
  });
}

function CloseTooltips() {
  let openElements = document.getElementsByClassName(
    'c-journey__article-content__list-content',
  );

  [...openElements].forEach((openElement) => {
    if (openElement.classList.contains('show-tooltips')) {
      openElement.classList.remove('show-tooltips');
    }
  });
}

function CloseTooltipsButton() {
  let closeButtons = document.querySelectorAll('.close-tooltips');

  [...closeButtons].forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      CloseTooltips();
    });
  });
}

export function init() {
  OpenTooltips();
  CloseTooltipsButton();
}
